import {
  newThingUI
} from './create'

export const create = {
  newThingUI
}
